module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "prime-logo-gray.34c75e17.svg";